import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { PrType, ProductTypeService, PrTypeData } from '../../services/product-type.service';
import { Utils } from '../../util';

@Component({
  selector: 'app-create-pr-type',
  templateUrl: './create-pr-type.component.html',
  styleUrls: ['./create-pr-type.component.css']
})
export class CreatePrTypeComponent implements OnInit {

  errorCode: string;

  prTypeForm: FormGroup;

  constructor(
    private prTypeService: ProductTypeService,
    private data: PrTypeData,
    private fb: FormBuilder,
  ) {
  }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.prTypeForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      code: ['',Validators.required]
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    value.selection = 'venta';
    let sub = this.prTypeService.codeExistVenta(value.code).subscribe(data => {
      sub.unsubscribe();
      if(!data.length){
        if(value.code.length == 4){
          this.prTypeService.addPrType(value);
        }else{
          this.errorCode='El código debe de ser de cuatro letras'
        }
      }else{
        this.errorCode='Este código ya existe, seleccione otro.';
      }
 
    });
    
  }
}
